import { apiSlice } from "../api/apiSlice";

export const assignmentApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAssignments: builder.query({
      query: () => "/assignments",
    }),
    addAssignment: builder.mutation({
      query: (body) => ({
        url: "/assignments",
        method: "POST",
        body,
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        try {
          const res = await queryFulfilled;
          if (res.data) {
            dispatch(
              apiSlice.util.updateQueryData(
                "getAssignments",
                undefined,
                (draft) => {
                  draft.push(res.data);
                }
              )
            );
          }
        } catch (error) {
          console.log(error);
        }
      },
    }),
    deleteAssignment: builder.mutation({
      query: (id) => ({
        url: `/assignments/${id}`,
        method: "DELETE",
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        const pathResult = dispatch(
          apiSlice.util.updateQueryData(
            "getAssignments",
            undefined,
            (draft) => {
              return draft.filter((item) => item.id !== id);
            }
          )
        );

        try {
          await queryFulfilled;
        } catch (error) {
          pathResult.undo();
        }
      },
    }),
    editAssignment: builder.mutation({
      query: (body) => ({
        url: `/assignments/${body.id}`,
        method: "PATCH",
        body,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const response = await queryFulfilled;

        if (response?.data?.id) {
          dispatch(
            apiSlice.util.updateQueryData("getAssignments", undefined, (draft) => {
              let indexToUpdate = draft.findIndex(
                (task) => task.id == arg.id.toString()
              );
              if (indexToUpdate !== -1) {
                draft[indexToUpdate] = response.data;
              }
            })
          );

          dispatch(
            apiSlice.util.updateQueryData(
              "getVideo",
              arg.id.toString(),
              (draft) => {
                Object.assign(draft, response.data);
              }
            )
          );
        }
      },
    }),
    getAssignment: builder.query({
      query: (id) => `/assignments/${id}`,
    }),
  }),
});

export const {
  useGetAssignmentsQuery,
  useAddAssignmentMutation,
  useDeleteAssignmentMutation,
  useEditAssignmentMutation,
  useGetAssignmentQuery,
} = assignmentApi;
